// Salon links the builder can fill in itself. {{BookingLink}} is resolved by
// the sending engine (it personalises it per client); the gift voucher shop
// and online shop are plain public pages, so templates carry {{GiftCardLink}}
// and {{ShopLink}} and the builder swaps in the salon's real addresses as soon
// as a template is opened. Nothing unresolved ever reaches a send: without a
// salon address they fall back to the booking link.
import siteSetting from '../../../../../config/env'
import { getShareContext } from '../../../../shared/shareLinks'

const WEB = (siteSetting && siteSetting.api && siteSetting.api.weburl) || '/'

export const LOCAL_LINK_TAGS = ['GiftCardLink', 'ShopLink']

export const salonLinks = (hairdresser) => {
  const { salonSlug } = getShareContext(hairdresser)
  if (!salonSlug) return { GiftCardLink: '{{BookingLink}}', ShopLink: '{{BookingLink}}' }
  const base = `${WEB}book/${salonSlug}`
  return { GiftCardLink: `${base}/gift-cards`, ShopLink: `${base}/shop` }
}

const TAG_RE = /\{\{\s*(GiftCardLink|ShopLink)\s*\}\}/g
const swap = (value, links) => {
  if (typeof value === 'string') return value.replace(TAG_RE, (m, key) => links[key] || '{{BookingLink}}')
  if (Array.isArray(value)) return value.map(v => swap(v, links))
  if (value && typeof value === 'object') {
    const out = {}
    Object.keys(value).forEach(k => { out[k] = swap(value[k], links) })
    return out
  }
  return value
}
export const resolveLocalLinks = (blocks, links) => (blocks || []).map(b => (b ? { ...b, content: swap(b.content, links || {}) } : b))
